import React from "react";

export default function UserMessage({ message }) {
  return (
    <div className="flex justify-end">
      <div className="max-w-[75%] bg-white border border-gray-200 rounded-2xl rounded-tr-md px-4 py-2.5 text-gray-900 shadow-sm">
        <p className="text-[15px] leading-relaxed whitespace-pre-wrap">{message.text}</p>
      </div>
    </div>
  );
}
